import { buildFilterMapping } from '@/components/AgGrid/helpers/filterHelpers';

const filterMappingByColumnType = [
  {
    string: { filter: 'agTextColumnFilter' },
  },
  {
    number: { filter: 'agNumberColumnFilter' },
  },
  {
    integer: { filter: 'agNumberColumnFilter' },
  },
  {
    date: { filter: 'customDateFilter' },
  },
  {
    boolean: { filter: 'booleanColumnFilter' },
  },
  {
    amount: { filter: 'agNumberColumnFilter' },
  },
  {
    select: { filter: 'customSetColumnFilter' },
  },
  {
    static_select: { filter: 'customSetColumnFilter' },
  },
  {
    linkedString: { filter: 'agTextColumnFilter' },
  },
  {
    colorString: { filter: 'agTextColumnFilter' },
  },
  {
    approvalsSet: { filter: 'customSetColumnFilter' },
  },
];

export const filterMapping = buildFilterMapping(filterMappingByColumnType);
